import { Avatar, Box, Typography } from '@mui/material';

import { useUser } from 'hooks/useUser';

import { UserType } from 'routes/Dashboard';

import type { DrawerProps } from '../types';
import Drawer from '..';

import profileStyles from './styles';

const userTypeLabel: Record<UserType, string> = {
  [UserType.PROFESSIONAL]: 'Profissional',
  [UserType.PACIENT]: 'Paciente',
};

const Profile = ({ onClose, isOpen, anchor }: DrawerProps): JSX.Element => {
  const { user } = useUser();
  const typeLabel =
    user?.type != null &&
    Object.values(UserType).includes(user.type as UserType)
      ? userTypeLabel[user.type as UserType]
      : '';

  return (
    <Drawer open={isOpen} anchor={anchor} onClose={onClose} title="Perfil">
      <Box sx={profileStyles.root}>
        <Avatar
          alt={user?.name ? `Avatar de ${user.name}` : 'Avatar'}
          sx={profileStyles.avatar}
        >
          {user?.name?.[0] ?? '?'}
        </Avatar>
        <Box sx={profileStyles.textBlock}>
          <Typography variant="subtitle1" sx={profileStyles.name}>
            {user?.name ?? '—'}
          </Typography>
          {user?.email ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={profileStyles.email}
            >
              {user.email}
            </Typography>
          ) : null}
          {typeLabel ? (
            <Typography
              variant="caption"
              color="text.secondary"
              sx={profileStyles.typeCaption}
            >
              {typeLabel}
            </Typography>
          ) : null}
        </Box>
      </Box>
    </Drawer>
  );
};

export default Profile;
